"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[505],{

/***/ 56875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40102);


const Button = (param)=>{
    let { children , ...rest } = param;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(StyledButton, {
        type: "button",
        ...rest,
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);
const StyledButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button", {
    target: "epqktyx0"
})("all:unset;cursor:pointer;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, ";border-radius:8px;padding:12px;font-size:1rem;text-align:center;transition:background-color 0.2s;&:active{background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray5;
}, ";}&:disabled{background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray3;
}, ";}");


/***/ }),

/***/ 81919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75578);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32746);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40102);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56875);




const LabelButton = (param)=>{
    let { children , size ="small" , withIcon =false , ...rest } = param;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StyledLabelButton, {
        size: size,
        withIcon: withIcon,
        ...rest,
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LabelButton);
const StyledLabelButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e10ugv0c0"
})("padding:8px;background-color:inherit;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray5;
}, ";display:flex;align-items:center;&:active{background-color:inherit;}&:disabled{background-color:inherit;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray3;
}, ";}", (param)=>{
    let { size  } = param;
    return size === "small" && smallCss;
}, " ", (param)=>{
    let { theme , withIcon  } = param;
    return withIcon && withIconCss(theme);
});
const smallCss = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)("font-size:12px;");
const withIconCss = (theme)=>/*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)("color:", theme.colors.gray3, ";");


/***/ }),

/***/ 15110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40102);
/* harmony import */ var _icon_IconInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19340);



const Chip = (param)=>{
    let { label , color ="default" , icon , onClick  } = param;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(Wrapper, {
        color: color,
        onClick: onClick,
        children: [
            icon !== null && icon !== void 0 ? icon : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_icon_IconInfo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                width: 16,
                height: 16,
                viewBox: "0 0 16 16"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chip);
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span", {
    target: "eul0ouq0"
})({
    display: "inline-flex",
    alignItems: "center",
    padding: "8px 16px",
    borderRadius: "50px",
    "*:first-of-type": {
        marginRight: "4px"
    }
}, (param)=>{
    let { theme , color  } = param;
    return {
        ...theme.typographies.body1,
        fontWeight: 500,
        ...color === "default" && {
            backgroundColor: theme.colors.white,
            color: theme.colors.gray4
        },
        ...color === "black" && {
            backgroundColor: theme.colors.black,
            color: theme.colors.white
        },
        ...color === "gray" && {
            backgroundColor: theme.colors.gray1,
            color: theme.colors.gray4
        }
    };
});


/***/ }),

/***/ 58255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ graphic_Graphic; }
});

// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./src/components/graphic/Graphic10Kg.tsx
var Graphic10Kg = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/components/graphic/GraphicAirpods.tsx
var GraphicAirpods = __webpack_require__(66352);
// EXTERNAL MODULE: ./src/components/graphic/GraphicAppleWatch.tsx
var GraphicAppleWatch = __webpack_require__(91917);
// EXTERNAL MODULE: ./src/components/graphic/GraphicBattery.tsx
var GraphicBattery = __webpack_require__(26523);
// EXTERNAL MODULE: ./src/components/graphic/GraphicBowling.tsx
var GraphicBowling = __webpack_require__(85564);
// EXTERNAL MODULE: ./src/components/graphic/GraphicBus.tsx
var GraphicBus = __webpack_require__(53702);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCamera.tsx
var GraphicCamera = __webpack_require__(89617);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCard.tsx
var GraphicCard = __webpack_require__(97348);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCarrier.tsx
var GraphicCarrier = __webpack_require__(31229);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCharger.tsx
var GraphicCharger = __webpack_require__(75497);
// EXTERNAL MODULE: ./src/components/graphic/GraphicCurlingIron.tsx
var GraphicCurlingIron = __webpack_require__(90668);
// EXTERNAL MODULE: ./src/components/graphic/GraphicEtc.tsx
var GraphicEtc = __webpack_require__(96658);
// EXTERNAL MODULE: ./src/components/graphic/GraphicEyeDrops.tsx
var GraphicEyeDrops = __webpack_require__(20240);
// EXTERNAL MODULE: ./src/components/graphic/GraphicFriends.tsx
var GraphicFriends = __webpack_require__(51145);
// EXTERNAL MODULE: ./src/components/graphic/GraphicGlasses.tsx
var GraphicGlasses = __webpack_require__(71687);
// EXTERNAL MODULE: ./src/components/graphic/GraphicGym.tsx
var GraphicGym = __webpack_require__(5394);
// EXTERNAL MODULE: ./src/components/graphic/GraphicHandbag.tsx
var GraphicHandbag = __webpack_require__(652);
// EXTERNAL MODULE: ./src/components/graphic/GraphicHeadband.tsx
var GraphicHeadband = __webpack_require__(4083);
// EXTERNAL MODULE: ./src/components/graphic/GraphicHeadphones.tsx
var GraphicHeadphones = __webpack_require__(83115);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(75578);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 2 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(79214);
// EXTERNAL MODULE: ./src/components/svg/Svg.tsx
var Svg = __webpack_require__(24555);
;// CONCATENATED MODULE: ./src/components/graphic/GraphicIdCard.tsx



const GraphicIdCard = (param)=>{
    let { isAct =false , ...rest } = param;
    const theme = (0,emotion_element_cbed451f_browser_esm.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Svg/* default */.Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#clip0_2627_61534)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M1.5625 6.76719C1.5625 5.85592 2.30123 5.11719 3.2125 5.11719H21.9125C22.8238 5.11719 23.5625 5.85592 23.5625 6.76719V18.8672C23.5625 19.7785 22.8238 20.5172 21.9125 20.5172H3.2125C2.30123 20.5172 1.5625 19.7785 1.5625 18.8672V6.76719Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                        cx: "7.90336",
                        cy: "12.294",
                        r: "1.72367",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M11.3473 16.9371C11.3866 17.2104 11.1591 17.4355 10.8829 17.4355C10.2739 17.4355 9.16866 17.4355 7.90625 17.4355C6.64384 17.4355 5.53859 17.4355 4.92956 17.4355C4.65342 17.4355 4.42591 17.2104 4.46516 16.9371C4.70693 15.2532 6.15546 13.959 7.90625 13.959C9.65704 13.959 11.1056 15.2532 11.3473 16.9371Z",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        x: "13.2734",
                        y: "11.4355",
                        width: "7.83594",
                        height: "1",
                        rx: "0.5",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        x: "13.2734",
                        y: "13.5039",
                        width: "7.83594",
                        height: "1",
                        rx: "0.5",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        x: "13.2734",
                        y: "15.5723",
                        width: "7.83594",
                        height: "1",
                        rx: "0.5",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M1.5625 6.61719C1.5625 5.78876 2.23407 5.11719 3.0625 5.11719H22.0625C22.8909 5.11719 23.5625 5.78876 23.5625 6.61719V8.61719H1.5625V6.61719Z",
                        fill: isAct ? theme.colors.secondary : theme.colors.gray2
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "clip0_2627_61534",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "22",
                        height: "15.4",
                        fill: "white",
                        transform: "translate(1.5625 5.11719)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var graphic_GraphicIdCard = (GraphicIdCard);

// EXTERNAL MODULE: ./src/components/graphic/GraphicKey.tsx
var GraphicKey = __webpack_require__(65786);
// EXTERNAL MODULE: ./src/components/graphic/GraphicLipbalm.tsx
var GraphicLipbalm = __webpack_require__(19915);
// EXTERNAL MODULE: ./src/components/graphic/GraphicMask.tsx
var GraphicMask = __webpack_require__(97239);
// EXTERNAL MODULE: ./src/components/graphic/GraphicMat.tsx
var GraphicMat = __webpack_require__(85218);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPassport.tsx
var GraphicPassport = __webpack_require__(11177);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPC.tsx
var GraphicPC = __webpack_require__(37395);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPerfume.tsx
var GraphicPerfume = __webpack_require__(55161);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPill.tsx
var GraphicPill = __webpack_require__(66370);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPlane.tsx
var GraphicPlane = __webpack_require__(5181);
// EXTERNAL MODULE: ./src/components/graphic/GraphicPouch.tsx
var GraphicPouch = __webpack_require__(94761);
// EXTERNAL MODULE: ./src/components/graphic/GraphicProtein.tsx
var GraphicProtein = __webpack_require__(83204);
// EXTERNAL MODULE: ./src/components/graphic/GraphicRoaming.tsx
var GraphicRoaming = __webpack_require__(32276);
// EXTERNAL MODULE: ./src/components/graphic/GraphicRun.tsx
var GraphicRun = __webpack_require__(22700);
// EXTERNAL MODULE: ./src/components/graphic/GraphicSchool.tsx
var GraphicSchool = __webpack_require__(64625);
;// CONCATENATED MODULE: ./src/components/graphic/GraphicShake.tsx



const GraphicShake = (param)=>{
    let { isAct =false , ...rest } = param;
    const theme = (0,emotion_element_cbed451f_browser_esm.a)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Svg/* default */.Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#clip0_2604_61141)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M16.6066 1.77815L11.0724 19.8935C11.0321 20.0256 11.1064 20.1653 11.2385 20.2057L12.2703 20.5209C12.4024 20.5612 12.5421 20.4869 12.5825 20.3548L18.1167 2.23947C18.157 2.10743 18.0827 1.96768 17.9506 1.92734L16.9188 1.6121C16.7867 1.57176 16.647 1.64611 16.6066 1.77815Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M16.4879 24.0957H10.211C9.72725 24.0957 9.31287 23.7495 9.2269 23.2734L8.80232 20.9227L7.52658 13.8596L6.71094 9.34375H19.2438L18.6699 13.8596L17.7721 20.9227L17.4799 23.2218C17.4164 23.7213 16.9914 24.0957 16.4879 24.0957Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M18.6296 7.21289H7.02662C6.6505 7.21289 6.30618 7.42395 6.1355 7.75912L5.69826 8.61779C5.52887 8.95044 5.77052 9.34467 6.14382 9.34467H19.5124C19.8857 9.34467 20.1274 8.95044 19.958 8.61779L19.5207 7.75912C19.3501 7.42395 19.0058 7.21289 18.6296 7.21289Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M18.6667 13.8594H7.52344L8.79917 20.9225H17.769L18.6667 13.8594Z",
                        fill: isAct ? theme.colors.primary : theme.colors.gray3
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "clip0_2604_61141",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "15",
                        height: "22.5566",
                        fill: "white",
                        transform: "translate(5.32812 1.53906)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var graphic_GraphicShake = (GraphicShake);

// EXTERNAL MODULE: ./src/components/graphic/GraphicSocket.tsx
var GraphicSocket = __webpack_require__(12791);
// EXTERNAL MODULE: ./src/components/graphic/GraphicSportSwear.tsx
var GraphicSportSwear = __webpack_require__(32185);
// EXTERNAL MODULE: ./src/components/graphic/GraphicStrap.tsx
var GraphicStrap = __webpack_require__(59732);
// EXTERNAL MODULE: ./src/components/graphic/GraphicSunglasses.tsx
var GraphicSunglasses = __webpack_require__(3006);
// EXTERNAL MODULE: ./src/components/graphic/GraphicSwim.tsx
var GraphicSwim = __webpack_require__(22312);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTeeth.tsx
var GraphicTeeth = __webpack_require__(56881);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTissue.tsx
var GraphicTissue = __webpack_require__(4348);
// EXTERNAL MODULE: ./src/components/graphic/GraphicToescoks.tsx
var GraphicToescoks = __webpack_require__(27043);
// EXTERNAL MODULE: ./src/components/graphic/GraphicToiletries.tsx
var GraphicToiletries = __webpack_require__(20816);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTowel.tsx
var GraphicTowel = __webpack_require__(21809);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTube.tsx
var GraphicTube = __webpack_require__(52783);
// EXTERNAL MODULE: ./src/components/graphic/GraphicTumbler.tsx
var GraphicTumbler = __webpack_require__(98557);
// EXTERNAL MODULE: ./src/components/graphic/GraphicUnderwear.tsx
var GraphicUnderwear = __webpack_require__(32844);
// EXTERNAL MODULE: ./src/components/graphic/GraphicWallet.tsx
var GraphicWallet = __webpack_require__(4778);
// EXTERNAL MODULE: ./src/components/graphic/GraphicWork.tsx
var GraphicWork = __webpack_require__(44657);
;// CONCATENATED MODULE: ./src/components/graphic/Graphic.tsx



















































const graphicElement = (type)=>{
    switch(type){
        case "BOWLING":
            return GraphicBowling/* default */.Z;
        case "BUS":
            return GraphicBus/* default */.Z;
        case "CAMERA":
            return GraphicCamera/* default */.Z;
        case "ETC":
            return GraphicEtc/* default */.Z;
        case "FRIENDS":
            return GraphicFriends/* default */.Z;
        case "GYM":
            return GraphicGym/* default */.Z;
        case "PLANE":
            return GraphicPlane/* default */.Z;
        case "RUN":
            return GraphicRun/* default */.Z;
        case "SCHOOL":
            return GraphicSchool/* default */.Z;
        case "SWIM":
            return GraphicSwim/* default */.Z;
        case "TUBE":
            return GraphicTube/* default */.Z;
        case "WORK":
            return GraphicWork/* default */.Z;
        case "10KG":
            return Graphic10Kg/* default */.Z;
        case "CARD":
            return GraphicCard/* default */.Z;
        case "PC":
            return GraphicPC/* default */.Z;
        case "AIRPODS":
            return GraphicAirpods/* default */.Z;
        case "HANDBAG":
            return GraphicHandbag/* default */.Z;
        case "LIPBALM":
            return GraphicLipbalm/* default */.Z;
        case "APPLEWATCH":
            return GraphicAppleWatch/* default */.Z;
        case "BATTERY":
            return GraphicBattery/* default */.Z;
        case "CARRIER":
            return GraphicCarrier/* default */.Z;
        case "CHARGER":
            return GraphicCharger/* default */.Z;
        case "CURLINGIRON":
            return GraphicCurlingIron/* default */.Z;
        case "EYEDROPS":
            return GraphicEyeDrops/* default */.Z;
        case "GLASSES":
            return GraphicGlasses/* default */.Z;
        case "HEADBAND":
            return GraphicHeadband/* default */.Z;
        case "HEADPHONES":
            return GraphicHeadphones/* default */.Z;
        case "IDCARD":
            return graphic_GraphicIdCard;
        case "KEY":
            return GraphicKey/* default */.Z;
        case "MASK":
            return GraphicMask/* default */.Z;
        case "MAT":
            return GraphicMat/* default */.Z;
        case "PASSPORT":
            return GraphicPassport/* default */.Z;
        case "PERFUME":
            return GraphicPerfume/* default */.Z;
        case "PILL":
            return GraphicPill/* default */.Z;
        case "POUCH":
            return GraphicPouch/* default */.Z;
        case "PROTEIN":
            return GraphicProtein/* default */.Z;
        case "ROAMING":
            return GraphicRoaming/* default */.Z;
        case "SHAKE":
            return graphic_GraphicShake;
        case "SOCKET":
            return GraphicSocket/* default */.Z;
        case "SPORTSWEAR":
            return GraphicSportSwear/* default */.Z;
        case "STRAP":
            return GraphicStrap/* default */.Z;
        case "SUNGLASSES":
            return GraphicSunglasses/* default */.Z;
        case "TEETH":
            return GraphicTeeth/* default */.Z;
        case "TISSUE":
            return GraphicTissue/* default */.Z;
        case "TOESCOKS":
            return GraphicToescoks/* default */.Z;
        case "TOILETRIES":
            return GraphicToiletries/* default */.Z;
        case "TOWEL":
            return GraphicTowel/* default */.Z;
        case "TUMBLER":
            return GraphicTumbler/* default */.Z;
        case "UNDERWEAR":
            return GraphicUnderwear/* default */.Z;
        case "WALLET":
            return GraphicWallet/* default */.Z;
        default:
            return GraphicEtc/* default */.Z;
    }
};
const Graphic = (param)=>{
    let { type , isAct , ...rest } = param;
    return /*#__PURE__*/ (0,react.createElement)(graphicElement(type), {
        isAct,
        ...rest
    });
};
/* harmony default export */ var graphic_Graphic = (Graphic);


/***/ }),

/***/ 52976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24555);


const IconAdd = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M12 6.5V12M12 12V17.5M12 12H17.5M12 12H6.5",
            stroke: "#C7C7D0",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconAdd);


/***/ }),

/***/ 74677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24555);


const IconAlarm = (param)=>/*#__PURE__*/ {
    let { isNew =false , ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.3995 12.6659L21.2812 15.2319C22.2582 16.564 21.3068 18.4414 19.6548 18.4414L4.32061 18.4414C2.6686 18.4414 1.71727 16.564 2.69421 15.2319L4.57586 12.666L4.57586 8.91203C4.57586 4.81859 7.89426 1.50019 11.9877 1.50019C16.0811 1.50019 19.3995 4.81858 19.3995 8.91203L19.3995 12.6659Z",
                fill: "#9090A0"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.49243 20.0298C9.00124 21.469 10.3739 22.5002 11.9874 22.5002C13.6009 22.5002 14.9736 21.469 15.4824 20.0298H8.49243Z",
                fill: "#9090A0"
            }),
            isNew && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("circle", {
                cx: "22",
                cy: "2",
                r: "2",
                fill: "#F5656A"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconAlarm);


/***/ }),

/***/ 85099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24555);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62429);



const HOME_COLOR = (isAct)=>isAct ? {
        rect: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.black */ .Z.colors.black,
        path: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.white */ .Z.colors.white
    } : {
        rect: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.gray2 */ .Z.colors.gray2,
        path: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.white */ .Z.colors.white
    };
const IconHome = (param)=>/*#__PURE__*/ {
    let { isAct =false , ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("rect", {
                x: "1.5",
                y: "1.5",
                width: "21",
                height: "21",
                rx: "5",
                fill: HOME_COLOR(isAct).rect,
                style: {
                    transition: "fill .3s"
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: "M16.125 9.46191L11.4017 14.1852C11.2064 14.3805 10.8898 14.3805 10.6946 14.1852L7.875 11.3657",
                stroke: HOME_COLOR(isAct).path,
                strokeWidth: "2",
                strokeLinecap: "round",
                style: {
                    transition: "stroke .3s"
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconHome);


/***/ }),

/***/ 19340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24555);


const IconInfo = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("rect", {
                width: "16",
                height: "16",
                rx: "4",
                fill: "#E9E9EE"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M7.20741 14H8.79259V5.34661H7.20741V14ZM7 3.00398C7.00741 3.56175 7.45926 4.01594 8.00741 4.00797C8.54815 4.01594 9 3.56175 9 3.00398C9 2.44622 8.54815 2 8.00741 2C7.45926 2 7.00741 2.44622 7 3.00398Z",
                fill: "#C7C7D0"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconInfo);


/***/ }),

/***/ 21817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24555);


const IconMenu = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M4 7.5H20",
                stroke: "#9090A0",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M4 12H20",
                stroke: "#9090A0",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M4 16.5H20",
                stroke: "#9090A0",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMenu);


/***/ }),

/***/ 66356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24555);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62429);



const SEARCH_COLOR = (isAct)=>isAct ? {
        rect: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.black */ .Z.colors.black,
        circle: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.black */ .Z.colors.black
    } : {
        rect: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.gray2 */ .Z.colors.gray2,
        circle: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.gray2 */ .Z.colors.gray2
    };
const IconSearch = (param)=>/*#__PURE__*/ {
    let { isAct =false , ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("rect", {
                width: "2",
                height: "14.35",
                rx: "1",
                transform: "matrix(-0.707107 0.707107 0.707107 0.707107 12.75 11.3398)",
                fill: SEARCH_COLOR(isAct).rect,
                style: {
                    transition: "fill .3s"
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                cx: "10.1622",
                cy: "10.1621",
                r: "9.35",
                transform: "rotate(-45 10.1622 10.1621)",
                fill: SEARCH_COLOR(isAct).circle,
                stroke: "white",
                strokeWidth: "1.5",
                style: {
                    transition: "fill .3s"
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconSearch);


/***/ }),

/***/ 17652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75578);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7978);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40102);
/* harmony import */ var _icon_IconHome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85099);
/* harmony import */ var _icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66356);






const ROUTE_MATCH_ELEMENT = [
    {
        route: "/",
        matchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconHome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            isAct: true
        }),
        nonMatchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconHome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    },
    {
        route: "/template",
        matchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            isAct: true
        }),
        nonMatchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
    }
];
/**
 * 
 * @example
 * 
 * ```
 * HomePage.getLayout = function getLayout(page: ReactElement) {
    return (
      <>
        {page}
        <BottomNavigation />
      </>
    );
  };
  ```
 */ const BottomNavigation = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Wrapper, {
                children: ROUTE_MATCH_ELEMENT.map((param)=>/*#__PURE__*/ {
                    let { route , matchElement , nonMatchElement  } = param;
                    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Anchor, {
                        href: route,
                        children: router.asPath === route ? matchElement : nonMatchElement
                    }, route);
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrollableDiv, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomNavigation);
const HEIGHT = "56px";
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section", {
    target: "egppwp20"
})({
    width: "100%",
    height: HEIGHT,
    position: "fixed",
    bottom: 0,
    left: 0,
    display: "flex"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white,
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});
const Anchor = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "egppwp21"
})({
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const ScrollableDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "egppwp22"
})({
    height: HEIGHT,
    appearance: "none"
});


/***/ }),

/***/ 58720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75578);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77182);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40102);
/* harmony import */ var _icon_IconAlarm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74677);
/* harmony import */ var _icon_IconMenu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21817);
/* harmony import */ var _hooks_common_useToggle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70193);







const Drawer = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>__webpack_require__.e(/* import() */ 142).then(__webpack_require__.bind(__webpack_require__, 3142)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3142)
            ]
    }
});
const DefaultAppBar = ()=>{
    const [isDrawerShowing, _, toggleDrawerShowing] = (0,_hooks_common_useToggle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(false);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ButtonWrapper, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledLink, {
                            href: "/notice",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_icon_IconAlarm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Button, {
                            onClick: toggleDrawerShowing,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_icon_IconMenu__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Drawer, {
                isShowing: isDrawerShowing,
                setToClose: toggleDrawerShowing
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultAppBar);
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section", {
    target: "ej887y50"
})({
    position: "sticky",
    top: "0",
    left: "0",
    width: "100%",
    height: "48px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray1
    };
});
const ButtonWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "ej887y51"
})({
    position: "absolute",
    top: "0",
    right: "-12px",
    height: "100%",
    display: "flex"
});
const Button = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("button", {
    target: "ej887y52"
})({
    all: "unset",
    cursor: "pointer",
    width: "48px",
    height: "48px",
    textAlign: "center"
});
const StyledLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    target: "ej887y53"
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "48px",
    height: "48px"
});


/***/ }),

/***/ 63195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ USER_CATEGORY_QUERY_KEY; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97759);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70359);


const getCategories = ()=>(0,_lib_api__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)("/category/user");
const USER_CATEGORY_QUERY_KEY = "user_category";
const useGetUserCategories = ()=>{
    var ref;
    const query = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)({
        queryKey: [
            USER_CATEGORY_QUERY_KEY
        ],
        queryFn: getCategories
    });
    return {
        ...query,
        data: (ref = query.data) === null || ref === void 0 ? void 0 : ref.result
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetUserCategories);


/***/ }),

/***/ 70193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);

/**
 *
 * @param defaultValue
 * true | false
 *
 * @returns [value, setValue, toggle]
 *
 * @example
 * ```
 * const [value, _, toggle] = useToggle(false);
 * const [value, setValue, toggle] = useToggle(false);
 * ```
 */ const useToggle = (defaultValue)=>{
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        setValue((prev)=>!prev);
    }, []);
    return [
        value,
        setValue,
        toggle
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ })

}]);